import React from 'react';
import classnames from 'classnames'

import Presenter from '../../../presenter.js';
import Request from '../../request.props.js';

// Request prop for maintenance
import PresenterMaintenance from 'maintenance/presenter.js';
import RequestPropertiesMaintenance from 'maintenance/helper/request.props.js';

import { toast } from 'react-toastify';

// Modal Start Work And Finish
import ModalStartWork from 'maintenance/helper/component/Modal/ModalStartWork.js';
import ModalFinishWork from 'maintenance/helper/component/Modal/ModalFinishWork.js';

import MaintenanceWorkRow from './MaintenanceWorkRow.js';
import Pagination from '../../../../component/Pagination.js';
import {HandlingSometingWentWrong} from '../../../../utils/HandlingMessage.js';
import windowStop from '../../../../utils/windowStop.js';

const { ReactNativeWebView } = window;

export default class MaintenanceWorkList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modalStartWork    : false,
      modalFinishWork   : false,
      work: {
        alias: '',
      },

      isLoading       : true,
      loadingLoadMore : true,
      isSometingWrong : false,
      rawData         : [],
      NextPage        : null,
      // ***Pagination
      table_loading : false,
      current       : 0,
      limit         : 0,
      count         : 0,
    }

    this.openModalStartWork     = this.openModalStartWork.bind(this)
    this.closeModalStartWork    = this.closeModalStartWork.bind(this)

    this.openModalFinishWork    = this.openModalFinishWork.bind(this)
    this.closeModalFinishWork   = this.closeModalFinishWork.bind(this)

    this.onStartWork            = this.onStartWork.bind(this)
    this.onStartWorkSuccess     = this.onStartWorkSuccess.bind(this)
    this.onStartWorkFailed      = this.onStartWorkFailed.bind(this)

    this.onQuickTest            = this.onQuickTest.bind(this)
    this.onQuickTestSuccess     = this.onQuickTestSuccess.bind(this)
    this.onQuickTestFailed      = this.onQuickTestFailed.bind(this)
    
    // this.onFinishWork           = this.onFinishWork.bind(this)
    this.onFinishWorkSuccess    = this.onFinishWorkSuccess.bind(this)
    this.onFinishWorkFailed     = this.onFinishWorkFailed.bind(this)

    this.paramsPage    = 1;
    this.onReadWork    = this.onReadWork.bind(this)
    this.onReadSuccess = this.onReadSuccess.bind(this)
    this.onReadFailed  = this.onReadFailed.bind(this)
    this._mounted = false;
  }

  /**
  |--------------------------------------------------
  | Open & Close Modal Start 
  |--------------------------------------------------
  */
  openModalStartWork(alias){
    this.setState({
      work : {
        alias : alias,
      },
      modalStartWork : true
    })
  }

  closeModalStartWork(){
    this.setState({ modalStartWork : false })
  }

  /**
  |--------------------------------------------------
  | Open & Close Modal Finish 
  |--------------------------------------------------
  */
  openModalFinishWork(alias){
    this.setState({
      work : {
        alias : alias,
      },
      modalFinishWork : true
    })
  }

  closeModalFinishWork(){
    this.setState({ modalFinishWork : false })
  }

  /**
    |--------------------------------------------------
    | Function Start Work
    |--------------------------------------------------
    */
  onStartWork(data) {
    PresenterMaintenance.StartWork(
      RequestPropertiesMaintenance.StartWork(data, this, this.onStartWorkSuccess, this.onStartWorkFailed)
    )
  }

  onStartWorkSuccess(params, response) {
    toast.success("Execute Success")
    this.onReadWork('Work');
    this.closeModalStartWork();
  }

  onStartWorkFailed(response) {
    toast.error(response.data.detail);
  }


  /**
  |--------------------------------------------------
  | Function Quick Test
  |-------------------------------------------------- 
  */
  onQuickTest(alias) {
    PresenterMaintenance.QuickTest(
      RequestPropertiesMaintenance.QuickTest(alias, this, this.onQuickTestSuccess, this.onQuickTestFailed)
    )
  }
  onQuickTestSuccess(params, response) {
    toast.success("Quick Test Success")
    this.onReadWork('Work');
  }
  onQuickTestFailed(response) {
    try {
      toast.error(response.data.detail); 
    } catch (error) {
      console.log(error)
    }
  }


  /**
  |--------------------------------------------------
  | Function Finish Work
  |--------------------------------------------------
  */
  onFinishWorkSuccess(params, response) {
    this.onReadWork('Work');
    this.closeModalFinishWork();
  }

  onFinishWorkFailed(response) {
    console.log('Failed');
  }

  generateRow(row) {
    var element = row.map((val, index) => { 
      return (
        <MaintenanceWorkRow
          key={val.Alias}  
          RowData={val}
          onStartWork={this.openModalStartWork}
          onStartQuickTest={this.onQuickTest}
          onFinishWork={this.openModalFinishWork}
          UserReducer={this.props.UserReducer}
        />)
    })
    return element;
  }

  onReadWork(action) {
    if(this._mounted){
      Presenter.ReadByAsset(
        Request.ReadByAsset(action, this, this.onReadSuccess, this.onReadFailed, this.paramsPage)
      )
    }
  }

  onReadSuccess(params, response) {
    if(params.action === 'Work') {
      this.props.setAsset(response.data.results[0].Asset.Name, this.props.match.params.Owner)
      this.setState({
        isLoading       : false,
        loadingLoadMore : false,
        isSometingWrong : false,
        table_loading   : false,
        rawData         : response.data.results,
        NextPage        : response.data.next,
        current         : response.data.current,
        limit           : response.data.limit,
        count           : response.data.count,
      })
    } else if(params.action === "Next") {
      this.props.setAsset(this.props.match.params.AssetName, this.props.match.params.Owner)
      this.setState({
        isLoading       : 'success',
        loadingLoadMore : false,
        NextPage        : response.data.next,
        rawData         : [...this.state.rawData, ...response.data.results],
      })
    }
  }

  onReadFailed(response) {
    this.setState({
      isLoading: false,
      table_loading: false
    })
  }

  componentDidMount() {
    this._mounted = true;
    this.onReadWork('Work');
  }
  componentWillUnmount() {
    windowStop()
    this._mounted = false;
  }

  handlePageClick = (data) => {
    windowStop()
    let selected = data.selected + 1;
    this.paramsPage = selected
    this.setState({ table_loading: true})
    this.onReadWork('Work');
  };

  LoadMore() {        
    this.setState({loadingLoadMore: true,})
    this.onReadWork('Next')
  }

  RenderLoadMoreButton() {
    if(this.state.loadingLoadMore) {
      return(
        <div>
          <button className="btn btn-default" disabled><i className="fa fa-spinner fa-pulse fa-fw"></i>&nbsp;Loading</button>
        </div>
      )
    } else {
      if(this.state.NextPage != null) {
        return (
          <div>
            <button className="btn btn-primary" onClick={()=> {this.LoadMore()}}>Load More</button>
          </div>
        )
      }
    }
  }

  renderRowElement() {
    if ( this.state.isLoading ) {
      return (<tr><td className="table-loading-inside" colSpan="100%">Loading data . . .</td></tr>)
    } 
    else if(this.state.isLoading === false && this.state.isSometingWrong === true){
      return(HandlingSometingWentWrong('table'))
    }
    else if (this.state.rawData.length === 0) {
      return (<tr><td className="table-not-found" colSpan="100%"><span className="icon-drawer"></span>&nbsp;data empty</td></tr>)
    } 
    else if (this.state.rawData.length > 0) {
      return (this.generateRow(this.state.rawData))
    } 
    else {
      return(HandlingSometingWentWrong('table'))
    }
  }

  render() {
    // let {rawData, isLoading} = this.state 
    // let dataRow= null;

    // if(isLoading === 'loading') {
    //   dataRow = <tr><td className="table-loading-inside" colSpan="100%">Loading data . . .</td></tr>;

    // } else if(isLoading === 'success' && rawData.length == 0) {
    //   dataRow = <tr><td className="table-not-found" colSpan="100%"><span className="icon-drawer"></span>&nbsp;data empty</td></tr>;

    // } else if (isLoading === 'success' && rawData.length >= 0) {
    //   dataRow = this.generateRow(rawData)

    // } else if(isLoading === 'failed') {
    //   dataRow = <tr><td className="table-loading-inside" colSpan="100%">Failed load data</td></tr>;

    // } else {
    //   dataRow = <tr><td className="table-loading-inside" colSpan="100%">Something went wrong</td></tr>;
    // }

    return (
      <div>
        <table className={classnames("table table-hover table-outline mb-0 m-top-15 over-x", {"loading" : this.state.table_loading})}>        
          <thead className="thead-default">
            <tr>
              {ReactNativeWebView && ([
                <th className="text-center">Action</th>,
                <th className="text-center">Status</th>
              ])}
              <th>Maintenance Type</th>
              <th className="text-center">Scheduled Start</th>
              <th className="text-center">Scheduled End</th>
              <th className="text-center">Repeating</th>
              <th className="text-center">Reminder</th>
              <th className="text-center">Next Scheduled</th>
              {!ReactNativeWebView && ([
                <th key={1} className="text-center">Action</th>,
                <th key={2} className="text-center">Status</th>
              ])}
            </tr>
          </thead>
          <tbody>
            {this.renderRowElement()}
          </tbody>
        </table>
        <div className="row m-top-15">
          <div className="col-md-12 text-center">
            <Pagination
              current  = {this.state.current}
              count    = {this.state.count}
              limit    = {this.state.limit}
              handle   = {this.handlePageClick}
              isLoading= {this.state.table_loading}
            />
          </div>
        </div>
        <ModalStartWork
          modalStartWork  = {this.state.modalStartWork}
          work            = {this.state.work}
          closeModal      = {this.closeModalStartWork}
          onStartWork     = {this.onStartWork}
          UserReducer     = {this.props.UserReducer}
        />

        <ModalFinishWork
          modalFinishWork     = {this.state.modalFinishWork}
          work                = {this.state.work}
          closeModal          = {this.closeModalFinishWork}
          // onFinishWork     = {this.onFinishWork}
          onFinishWorkSuccess = {this.onFinishWorkSuccess}
          onFinishWorkFailed  = {this.onFinishWorkFailed}
          UserReducer         = {this.props.UserReducer}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/App/maintenance/helper/component/MaintenanceWorkList/MaintenanceWorkList.js